// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".select-item__right[data-v-bdeb81f2] {\n  padding-right: 30px;\n}\n.collapsible-container[data-v-bdeb81f2] {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height ease-out 300ms;\n}\n.collapsible-container--expanded[data-v-bdeb81f2] {\n  max-height: 5000px;\n  transition: max-height ease-in 300ms;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
